<div class="authors_container">
    <h3>{{ 'aproveIdeaModal.authors' | translate }}</h3>
    <div class="change_authors" *ngFor="let author of authorsPopulated">
      <div class="author-inputs">
        <div class="input_container">
          <label for="currentAuthor">{{ 'aproveIdeaModal.currentAuthor' | translate }}</label>
          <input id="currentAuthor" class="form-control" [value]="author.name" disabled />
        </div>
        <div class="input_container col-3">
          <label for="re">RE Atual</label>
          <input 
            id="re" 
            class="form-control" 
            [(ngModel)]="author.re"
            (change)="onAuthorChange()" 
          />
        </div>
      </div>
 

      <div class="new-author-inputs">
        <div class="input_container">
          <label for="newAuthor">{{ 'aproveIdeaModal.newAuthor' | translate }}</label>
          <input 
            id="newAuthor" 
            class="form-control" 
            [(ngModel)]="author.newName"
            (change)="onAuthorChange()" 
          />
        </div>
        <div class="input_container">
          <label for="reNewAuthor">RE novo autor</label>
          <input 
            id="reNewAuthor" 
            class="form-control" 
            [(ngModel)]="author.newRe"
            (change)="onAuthorChange()" 
          />
        </div>
        <div class="input_container">
          <label for="emailNewAuthor">E-mail novo autor</label>
          <input 
            id="emailNewAuthor" 
            class="form-control" 
            [(ngModel)]="author.newEmail"
            (change)="onAuthorChange()" 
          />
        </div>
      </div>
    </div>
  
    <div>
      <label>{{ 'aproveIdeaModal.authorChangeReason' | translate }}</label>
      <input (blur)="onAuthorChangeReason($event.target.value)"  class="form-control" />
    </div>
  </div>
  